import React, { useEffect, useContext } from 'react'
import { useRouter } from 'next/router'
import { FullscreenCaptions } from '@src/components/FullscreenCaptions'
import { Player } from '@src/components/Player'
import { LanguageContext } from '@src/context/LanguageContext'
import Layout from '../../components/Layout'
import { useWork } from '../../lib/apiClient'
import { logger } from '../../lib/logger'

const Work: React.FC = () => {
  const router = useRouter()
  const { id, includeInactive, srtLanguage } = router.query
  const {
    data: work, isError, isLoading, error,
  } = useWork(Number(id), Boolean(includeInactive))
  const { setCaptionsPreference } = useContext(LanguageContext)
  useEffect(() => {
    if (typeof srtLanguage === 'string' && work && work.parsedSrts.find((srt) => srt.shortDescriptor === srtLanguage)) {
      logger.info({ srtLanguage }, 'Setting language')
      setCaptionsPreference(srtLanguage)
    }
  }, [srtLanguage, setCaptionsPreference, work])

  return (
    <>
      <Layout exhibition={work?.exhibition} work={work} workIsLoading={isLoading} focusMode>
        {work
          && (
            <>
              <FullscreenCaptions work={work} />
              <Player work={work} />
            </>
          )}
        {isLoading && <p>Loading...</p>}
        {isError && <p>{error?.message || 'Error!'}</p>}
      </Layout>
    </>
  )
}

export default Work
